import { axios, setHttpToken } from "@/plugins/axios.js";
import { isEmpty } from "lodash";
import localforage from "localforage";
import bus from "@/bus";
import { locale } from "core-js";

export const register = ({ dispatch }, { user, context }) => {
  bus.$emit("showWait");
  return axios
    .post("auth/signup", user)
    .then((response) => {
      bus.$emit("hideWait");
      return Promise.resolve(response.data.data);
    })
    .catch((error) => {
      bus.$emit("hideWait");
      return Promise.reject(error.response);
    });
};

export const login = ({ commit, dispatch }, { user, context }) => {
  bus.$emit("showWait");
  return axios
    .post("auth/authorise", user)
    .then((response) => {
      return dispatch("setToken", response.data.token).then(() => {
        return dispatch("fetchUser")
          .then((user) => {
            return localforage.setItem("user", user).then(() => {
              dispatch("setUser", user);
              bus.$emit("hideWait");
              return Promise.resolveresponse;
            });
          })
          .catch((err) => {
            bus.$emit("hideWait");
            return Promise.reject(err.response);
          });
      });
    })
    .catch((error) => {
      bus.$emit("hideWait");
      return Promise.reject(error.response);
    });
};

export const resentEmailVerificationCode = (
  { dispatch },
  { user, context }
) => {
  bus.$emit("showWait");
  return axios
    .post("auth/resend/email/verification/code", { email: user.email })
    .then((response) => {
      dispatch("fetchUser");
      bus.$emit("hideWait");
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      return Promise.reject(err.response.data);
    });
};

export const logout = ({ dispatch }) => {
  bus.$emit("showWait", "ROOT:FULLSCREEN_WAIT:ALERT_MSG-TEXT|LOGOUT");

  return axios
    .get("auth/revoke/token?isRevokeAll=1")
    .then(() => {
      dispatch("clearAuth");
      bus.$emit("hideWait");
    })
    .catch((err) => {
      console.log(err);
      bus.$emit("hideWait");
      dispatch("clearAuth");
    });
};

export const verifyEmail = ({ dispatch }, salt) => {
  bus.$emit("showWait");
  return axios
    .get("auth/confirm/email/" + salt)
    .then((response) => {
      dispatch("fetchUser");
      bus.$emit("hideWait");
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      return Promise.reject(err.response.data);
    });
};

export const forgotPassword = (_, { user, context }) => {
  bus.$emit("showWait");
  return axios
    .post("auth/forgot/password/", user)
    .then((response) => {
      bus.$emit("hideWait");

      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      return Promise.reject(err.response.data);
    });
};

export const recoverPassword = (_, { user, context }) => {
  bus.$emit("showWait");
  user.token = user.reset_code;
  return axios
    .post("auth/reset/password/", user)
    .then((response) => {
      bus.$emit("hideWait");

      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      return Promise.reject(err.response);
    });
};

export const updateEmail = ({ dispatch }, { user, context }) => {
  bus.$emit("showWait");
  return axios
    .post("auth/update/email/", user)
    .then((response) => {
      dispatch("fetchUser");

      bus.$emit("hideWait");
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      return Promise.reject(err.response.data);
    });
};
export const updateProfile = ({ dispatch }, { profile, password, context }) => {
  bus.$emit("showWait");
  return axios
    .post("profile/update/", { ...profile, password })
    .then((response) => {
      dispatch("fetchUser");
      dispatch("me");

      bus.$emit("hideWait");
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      return Promise.reject(err.response.data);
    });
};

export const updatePassword = (_, { user, context }) => {
  bus.$emit("showWait");
  return axios
    .post("auth/update/password/", user)
    .then((response) => {
      bus.$emit("hideWait");
      //dispatch("logout"); // this wont redirect to login
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      return Promise.reject(err.response.data);
    });
};

export const updateAvatar = ({ dispatch }, { file, context }) => {
  if (!file.files[0]) {
    dispatch(
      "setAlert",
      { type: "error", message: "PLEASE_CHOOSE_AN_IMAGE" },
      { root: true }
    );
    return;
  }

  bus.$emit("showWait");

  var formData = new FormData();
  formData.append("avatar", file.files[0]);

  axios
    .post("profile/update/avatar", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(() => {
      dispatch("fetchUser").then(() => {
        context.imagePreview = null;
        bus.$emit("hideWait");
      });
    })
    .catch((err) => {
      bus.$emit("hideWait");
      if (!err.response)
        dispatch(
          "setAlert",
          { type: "error", message: "SOMETHING_WENT_WRONG", translate: true },
          { root: true }
        );
    });
};

export const fetchUser = ({ commit }) => {
  bus.$emit("showWait");
  return axios
    .get("auth/me")
    .then((response) => {
      commit("SET_AUTHENTICATED", true);
      commit("SET_USER", response.data);
      bus.$emit("hideWait");
      return Promise.resolve(response.data);
    })
    .catch((err) => {
      bus.$emit("hideWait");
      if (err.response) return Promise.reject("NOT_FOUND");
      else return Promise.reject("FAILED");
    });
};

export const setToken = ({ commit, dispatch }, token) => {
  if (isEmpty(token)) {
    return dispatch("checkTokenExists")
      .then((token) => {
        return setHttpToken(token);
      })
      .catch((err) => {
        console.log(err);
        return Promise.reject(err);
      });
  }
  commit("SET_TOKEN", token);
  return setHttpToken(token);
};

export const setUser = ({ commit }, user) => {
  commit("SET_USER", user);
};

export const getUserFromLocalStorage = ({ dispatch }) => {
  return dispatch("checkTokenExists")
    .then((token) => {
      return localforage
        .getItem("user")
        .then((user) => {
          if (user && user.id) {
            return Promise.resolve(user);
          }
          return Promise.reject("NO_STORAGE_USER");
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const checkTokenExists = ({ dispatch }) => {
  return localforage.getItem("authtoken").then((authtoken) => {
    if (isEmpty(authtoken)) {
      dispatch("clearAuth");
      return Promise.reject("NO_STORAGE_TOKEN");
    }

    return Promise.resolve(authtoken);
  });
};

export const clearAuth = ({ dispatch }) => {
  dispatch("auth/resetState", null, { root: true });
  localforage.setItem("user", null);
  setHttpToken(null);
};

export const resetState = ({ commit }) => {
  commit("SET_AUTHENTICATED", false);
  commit("SET_USER", null);
  commit("SET_TOKEN", null);
};
